module.exports = __webpack_public_path__ + "media/assets/images/flags/dk-27c78e3e8dd64dce6deb231b21204955.svg";